import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AmdSimpleTableParamsModel} from '../amd-simple-table/simple-table.component';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-full-screen-simple-table-dialog',
	templateUrl: './full-screen-simple-table-dialog.component.html',
	styleUrls: ['./full-screen-simple-table-dialog.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class FullScreenSimpleTableDialogComponent implements OnInit {
	amdSimpleTableParamsModel: AmdSimpleTableParamsModel;
	showMoreTableTitle: string;
	translateContext = TranslateContext;

	constructor() {
	}

	ngOnInit() {
	}

}
